import React, { useEffect } from 'react';
import { track } from '../services/analytics';
import TopNav from '../components/layout/TopNav';
import HeroSection from '../components/home/HeroSection';
import ExperiencesSection from '../components/home/ExperiencesSection';
import GearSection from '../components/home/GearSection';
import QuoteSection from '../components/home/QuoteSection';
import HomeFooter from '../components/home/HomeFooter';

const HomePage = () => {
  useEffect(() => {
    track('page_view', { page: 'home' });
  }, []);

  return (
    <div className="bg-surface text-on-surface font-body min-h-screen">
      <TopNav variant="transparent" />
      <main>
        <HeroSection />
        <ExperiencesSection />
        <GearSection />
        <QuoteSection />
      </main>
      <HomeFooter />
    </div>
  );
};

export default HomePage;
